<template>
  <div id="dashboard">
    <div
      v-if="showLogo"
      :style="{
        padding: '5px 15px',
        textAlign: 'right',
        height: '60px',
        borderBottom: '3px solid ' + distributorBrand.color,
      }"
    >
      <img
        style="width: 350px; max-height: 50px"
        :src="distributorBrand.logo"
        alt="logo"
      />
    </div>
    <div class="content project middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <p class="sub-title text-center"><b>BLACK NOVA</b> PARTNER PORTAL</p>
          <p class="sub-title text-center">TECHNICAL RESOURCES</p>
          <div class="row mt50">
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-4 mb30">
                  <router-link
                    class="w100 dash-button pt border"
                    to="/technical-support/resources"
                  >
                    <i
                      :style="{ lineHeight: userType == 'admin' ? 0.5 : 1, fontSize: userType == 'admin' ? '25px' : '36px' }" class="iconfont3 icon-IconDashboard-Manageusers3 pull-right"
                    ></i>
                    <div class="h42" :style="{ lineHeight: userType == 'admin' ? 0.5 : 1 }">
                      <b>TECHNICAL RESOURCES</b>
                    </div>
                  </router-link>
                  <router-link
                    v-if="userType == 'admin'"
                    class="dash-button db-top border"
                    style="
                      padding: 4px 20px;
                      height: 35px;
                      position: absolute;
                      left: 15px;
                      bottom: 0px;
                    "
                    to="/technical-support/resources/manage"
                  >
                    <i
                      class="iconfont3 icon-IconSettings font25 pull-right lh1"
                    ></i>
                    <div style="line-height: 25px">
                      <b>Backend</b>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-4 mb30">
                  <a
                    class="w100 dash-button border"
                    target="_blank"
                    href="https://blacknova.co/support-ticket-form/"
                  >
                    <i
                      class="iconfont3 icon-IconSupport font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>OPEN HELPDESK TICKETS</b>
                    </div>
                  </a>
                </div>
                <div class="col-xs-4 mb30">
                  <a
                    class="w100 dash-button border"
                    target="_blank"
                    href="https://blacknova.co/rma-form/"
                  >
                    <i
                      class="iconfont3 icon-IconSupport font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>OPEN RMA TICKET</b>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12" >
              <div class="border p20">
                <h4 class="b mb20">CONTACT OUR SUPPORT TEAM</h4>
                <a class="b black mr30 mb10" href="https://go.blacknova.co/SupportSessionBooking" target="_blank">BOOK A SUPPORT SESSION</a>
                <p>
                  <span class="b mr30 font13">EMEA HOTLINE No. +39 02 30579069</span>
                  <span class="b mr30 font13">AMERICAS HOTLINE No. +1 646 9746030</span>
                  <span class="b font13">APAC HOTLINE No. +852 58030270</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
export default {
  name: "dashboard",
  data() {
    return {
      loading: true,
      userType: this.$store.state.user ? this.$store.state.user.type : null,
      distributorBrand: {},
    };
  },
  async mounted() {
    if (
      this.userType == "distributors" &&
      this.$store.state.user.file_name != ""
    ) {
      if (
        typeof this.$store.state.user.file_name != "undefined" &&
        this.$store.state.user.file_name != ""
      ) {
        this.distributorBrand = {
          color: this.$store.state.user.color,
          logo:
            this.$store.state.serverURL +
            "/" +
            this.$store.state.user.file_name +
            "?" +
            Date.now(),
        };
      }
      if (
        this.userType == "dealers" ||
        this.userType == "distributorsmanager"
      ) {
        axios
          .get("/user/single/" + this.$store.state.user.created_by)
          .then((response) => {
            if (
              response.data &&
              typeof response.data.file_name != "undefined" &&
              response.data.file_name != ""
            ) {
              this.distributorBrand = {
                color: response.data.color,
                logo:
                  this.$store.state.serverURL +
                  "/" +
                  response.data.file_name +
                  "?" +
                  Date.now(),
              };
            }
          });
      }
    }
    this.loading = false;
  },
  computed: {
    showLogo() {
      return (
        (this.userType == "distributors" ||
          this.userType == "distributorsmanager" ||
          this.userType == "dealers") &&
        typeof this.distributorBrand.logo != "undefined"
      );
    },
  },
  created: function () {
    this.$parent.headerB();
    this.$parent.headerNoBg();
  },
};
</script>

<style>
</style>
